import { useMemo } from "react";
import { calculateManWithVanPricing, DEFAULT_MANWITHVAN_PRICING_CONFIG, } from "../services/pricing.js";
export function useManWithVanPricing(input) {
    return useMemo(() => {
        const config = input.config || DEFAULT_MANWITHVAN_PRICING_CONFIG;
        return calculateManWithVanPricing({ ...input, config });
    }, [input.hours, input.helpers, input.distanceMiles, input.config, input.minimums]);
}
//# sourceMappingURL=useManWithVanPricing.js.map